import { AxiosResponse } from 'axios'

// Utility function to handle file download from API response
export const downloadFileFromResponse = (
    response: AxiosResponse<any, any>,
    defaultFilename = 'export.xlsx',
): void => {
    let filename = defaultFilename
    const disposition = response.headers['content-disposition']
    if (disposition) {
        const match = disposition.match(/filename="?([^"]+)"?/)
        if (match) filename = match[1]
    }
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
}
